import getters from '@/store/modules/payment/getters';
import mutations from '@/store/modules/payment/mutations';
import actions from '@/store/modules/payment/actions';

export const state = {
  pageInfo: {},
  paymentInfo: {},
  paymentList: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
